
import { defineComponent } from 'vue'
import { bytesToSize } from '@remote/utils'
import { toast } from '@remote/utils/dialog'

export default defineComponent({
  name: 'FileInfo',
  props: {
    file: {
      type: Object,
      default: () => { },
    },
    check: {
      type: Boolean,
      default: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
    isHead: {
      type: Boolean,
      default: false,
    },
    isLimitDownloaded: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update', 'getIn'],
  data () {
    return {
    }
  },
  computed: {
    more () {
      if (this.check && this.file.isDir) {
        return true
      }
      return false
    },
  },
  methods: {
    bytesToSize,
    onClick () {
      this.$emit('update', this.file, this.index)
    },
    handleClick () {
      this.$emit('getIn', this.file, this.index)
    },
    handleOnClickDisabledToast () {
      if (this.file.is_download && this.isLimitDownloaded) toast('任务已在下载中队列')
    },
  },
})
